'use client';
import { ComponentProps } from 'react';
import { productDetailPayloadToBaseCarData } from 'src/data/ProductApi/ProductDetailPayloadToBaseCarData';
import { CarouselSection } from 'src/general/components/Carousel/CarouselSection';
import { ProductCard } from 'src/plp/components/ProductCard/ProductCard';
import { ProductListDataPayload } from 'src/types/CataloguePage.types';
import { pushToDataLayerProductCard } from 'src/utils/pushToDataLayer';
import styles from './SimilarCarsCarousel.module.scss';

interface SimilarCarsCarouselContentProps {
  results: ProductListDataPayload['results'];
}

const carouselName = 'similar-cars-carousel';

export const SimilarCarsCarouselContent = ({ results }: SimilarCarsCarouselContentProps) => {
  const tiles = generateTiles(results);

  return (
    <>
      <header className={styles.header}>
        <h2 className="c-fs-h4">Other cars you might like</h2>
      </header>
      <CarouselSection tiles={tiles} />
    </>
  );
};

const generateTiles = (results: ProductListDataPayload['results']): ComponentProps<typeof CarouselSection>['tiles'] => {
  const tiles = results.map((product, index) => ({
    id: product.sku,
    tile: (
      <ProductCard
        carData={productDetailPayloadToBaseCarData(product)}
        weeklyRepayment={product.weeklyRepayment}
        defaultRate={product.defaultRate}
        variant="default"
        onCardClick={() => {
          pushToDataLayerProductCard(product, index, {
            event: 'carousel_tile_click',
            name: carouselName,
            value: carouselName,
            variant: 'plp',
          });
        }}
      />
    ),
  }));

  return tiles;
};
